module.exports = __webpack_public_path__ + "img/logo-mobifone.64e8139e.png";